import { render, staticRenderFns } from "./Estudios.vue?vue&type=template&id=28c53abf&scoped=true"
import script from "./Estudios.vue?vue&type=script&lang=js"
export * from "./Estudios.vue?vue&type=script&lang=js"
import style0 from "./Estudios.vue?vue&type=style&index=0&id=28c53abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c53abf",
  null
  
)

export default component.exports